import { render, staticRenderFns } from "./complaintlList.vue?vue&type=template&id=30736dc2&scoped=true"
import script from "./complaintlList.vue?vue&type=script&lang=js"
export * from "./complaintlList.vue?vue&type=script&lang=js"
import style0 from "./complaintlList.vue?vue&type=style&index=0&id=30736dc2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30736dc2",
  null
  
)

export default component.exports